import { Box, ListItemButton } from "@mui/material";
import { Link } from "react-router-dom";

export default function NavItem({ item, fullPath, isActive, hideParent, isChild }) {
  if (item.isMenuItem) {
    const ListITemBtnSx = {
      minHeight: 40,
      borderRadius: 0.75,
      textTransform: "capitalize",
      fontWeight: isActive ? "fontWeightSemiBold" : "fontWeightRegular",
      position: "relative",
      ...(isChild && {
        paddingLeft: 5.5,
      }),
      "&:hover": {
        background: "linear-gradient(90deg, #84C7C6 0%, #004B49 100%)",
        borderRadius: 0,
      },
      ...(isActive && {
        background: "linear-gradient(90deg, #84C7C6 0%, #004B49 100%)",
        borderLeft: "2px solid #FDFDFD",
        borderRadius: 0,
        "&:hover": {
          background: "linear-gradient(90deg, #84C7C6 0%, #004B49 100%)",
        },
      }),
    };

    if (item.isBtn) {
      return (
        <ListItemButton
          sx={ListITemBtnSx}
          onClick={() => {
            item.onClick();
          }}
        >
          <Box
            component="span"
            sx={{
              color: "theme.palette.common.white",
              fontSize: "16px",
            }}
          >
            {item.name}
          </Box>
        </ListItemButton>
      );
    }

    return (
      <Link to={item.path || fullPath} style={{ textDecoration: "none" }}>
        <ListItemButton sx={ListITemBtnSx}>
          <Box
            component="span"
            sx={{
              color: "white",
              fontSize: "16px",
              flex: 1,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {item.name}
            {item.badge && (
              <Box
                sx={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "4px",
                  backgroundColor: "#AED581",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="span"
                  sx={{
                    color: "#33691E",
                    fontSize: "11px",
                    fontWeight: "bold",
                    lineHeight: 1,
                  }}
                >
                  {item.badge}
                </Box>
              </Box>
            )}
          </Box>
          {isActive && (
            <Box
              sx={{
                width: "24px",
                height: "24px",
                borderRadius: "4px",
                backgroundColor: "#FF6B35",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 1,
              }}
            >
              <Box
                component="span"
                sx={{
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                N
              </Box>
            </Box>
          )}
        </ListItemButton>
      </Link>
    );
  }

  if (hideParent) {
    return null;
  }

  if (item.isTopParent) {
    return null; // isTopParent는 RecursiveNav에서 처리
  }

  return null;
}
